import { Select } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import client from "../../helpers/Client";

export const RawCitySelect = ({ cities, city, setCity, ...rest}) => {
  /*
  A city select component that requires cities to be passed in as a prop.
  For automatic city list population, use the CitySelect component instead.
  */
  const defaultColor = "gray.500";
  const defaultBgColor = "gray.100";
  const _rest = {
    ...rest,
    color: rest.color || defaultColor,
    bg: rest.bgColor || defaultBgColor
  };
  return (
    <Select
      placeholder='Şehir'
      variant="outline"
      onChange={(e) => setCity(e.target.value)}
      value={city.url}
      {..._rest}
    >
      { // This is for assigning auto key to options.
        React.Children.toArray(
          cities.map((_option) => (
            <option value={_option.url}>{_option.name} </option>
          ))
        )
      }
    </Select>
  );
};

const CitySelect = ({ city, setCity, ...rest}) => {
  const [cities, setCities] = useState([]);
  useEffect(() => {
    client
      .get("/public/cities/")
      .then((response) => setCities(response.data))
      .catch((error) => console.error("Error fetching cities:", error));
  }, []);
  return <RawCitySelect {...{cities, city, setCity, ...rest}} />;
};

export default CitySelect;
